export enum ASK_AI_CONVERSATION {
    /**
     * @value Browsing appropriate tools
     */
    MATCHING_RULES = 'ASK_AI_CONVERSATION.MATCHING_RULES',
    /**
     * @value Searching sources for answers
     */
    SEARCHING_SOURCES = 'ASK_AI_CONVERSATION.SEARCHING_SOURCES',
    /**
     * @value Stop the streaming
     * @description Label of the streaming cancellation button in Ask AI Conversation
     */
    STOP_STREAMING = 'ASK_AI_CONVERSATION.STOP_STREAMING',
    /**
     * @value You stopped this response
     * @description Notify a user when they've manually cancelled the stream before the Ask AI answer was fully displayed
     */
    YOU_STOPPED_THIS_RESPONSE = 'ASK_AI_CONVERSATION.YOU_STOPPED_THIS_RESPONSE',
}
